import '@khmyznikov/pwa-install';
